import { filterFixedProducts, filterUsageProducts } from '@weft/services';
import type { FixedProduct, Plan, Promotion, UsageProduct } from '@weft/types';

export function usePlanCharges(plan: Plan) {
  const fixedProducts = filterFixedProducts<FixedProduct>(plan.products);
  const usageProducts = filterUsageProducts<UsageProduct>(plan.products);
  const promotions = plan.promotions satisfies Promotion[];
  
  return { fixedProducts, usageProducts, promotions };
}